<template>
    <div class="container padding-top-50">
        <div v-if="dataReceived">
            <router-view :key="$route.fullPath"></router-view>
        </div>
    </div>
</template>

<script>
  import { mapGetters, mapActions } from 'vuex'
  /**
   * Import Font Awesome for vue
   */
  import { library } from '@fortawesome/fontawesome-svg-core'
  import { fas } from '@fortawesome/free-solid-svg-icons'
  library.add(fas)

  export default {
    name: 'App',

    components: {
    },

    data: () => {
      return {
        dataReceived: true,
      }
    },

    methods: {
      ...mapActions('profile', ['fetchData']),
    },

    computed: {
      ...mapGetters('profile', ['profileData']),
    },

    beforeMount () {
      this.$store.dispatch('setPageTitle', this.$route.meta.title)
    },

    watch: {
      $route (to, from) {
        this.$store.dispatch('setPageTitle', to.meta.title)
      }
    }
  }
</script>

<style scoped>

</style>
